import React, { useEffect, useMemo, useState } from "react";

import {
  Container,
  ContentContainer,
  ContentContainerFlex,
  CalendarIcon,
  CalendarContainer,
  CalendarWrapper,
  ConfirmBtn,
  CalendarFilterContainer,
  CalendarIconClose,
  RangeDataText,
  RangeDataTextContainer,
  CustomCalendar,
  CalendarFilterText,
} from "./styled";

import DraggableAccordion from "components/Cards/DraggableAccordion";
import CreatorsTable from "components/Cards/CreatorsTable";
import Media from "components/Cards/Media";
import PieChartCard from "../PieChart";
import TotalViewsCard from "../TotalViews";
import ChartCard from "../ChartCard";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import 'react-calendar/dist/Calendar.css';


import { GetPosts, GetSumMetricsByInfluencerAndPlatform, GetSumMetricsGroupedByDate, GetSumAllMetrics } from "services/post-metrics";
import CloseIcon from '@mui/icons-material/Close';

import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');


export default function DashboardCampaignTab() {
  const [posts, setPost] = React.useState(null);
  const [table, setTable] = React.useState(null);
  const [sumMetricsGroupedByDate, setSumMetricsGroupedByDate] = React.useState(null);
  const [allMetrics, setAllMetrics] = React.useState(null);
  const [calendarIsOpen, setCalendarIsOpen] = React.useState(null);

  const params = useParams();

  const fetchPosts = async (selectedDate) => {
    try {
      const dateFormat = {
        startDate: selectedDate?.[0] ? dayjs(selectedDate[0]).format('YYYY-MM-DD') : "",
        endDate: selectedDate?.[1] ? dayjs(selectedDate[1]).format('YYYY-MM-DD') : "",
      };

      const { data } = await GetPosts(params?.id, { startDate: dateFormat.startDate, endDate: dateFormat.endDate });
      setPost(data);
    } catch (error) {

    } finally {
    }
  }

  const fetchTable = async (selectedDate) => {
    try {
      const dateFormat = {
        startDate: selectedDate?.[0] ? dayjs(selectedDate[0]).format('YYYY-MM-DD') : "",
        endDate: selectedDate?.[1] ? dayjs(selectedDate[1]).format('YYYY-MM-DD') : "",
      };

      const { data } = await GetSumMetricsByInfluencerAndPlatform(params?.id, { startDate: dateFormat.startDate, endDate: dateFormat.endDate });
      setTable(data);
    } catch (error) {

    } finally {
    }
  }

  const fetchSumMetricsGroupedByDate = async (selectedDate) => {
    try {
      const dateFormat = {
        startDate: selectedDate?.[0] ? dayjs(selectedDate[0]).format('YYYY-MM-DD') : "",
        endDate: selectedDate?.[1] ? dayjs(selectedDate[1]).format('YYYY-MM-DD') : "",
      };

      const { data } = await GetSumMetricsGroupedByDate(params?.id, { startDate: dateFormat.startDate, endDate: dateFormat.endDate });
      setSumMetricsGroupedByDate(data);
    } catch (error) {

    } finally {
    }
  }

  const sumAllMetrics = async (selectedDate) => {
    try {
      const dateFormat = {
        startDate: selectedDate?.[0] ? dayjs(selectedDate[0]).format('YYYY-MM-DD') : "",
        endDate: selectedDate?.[1] ? dayjs(selectedDate[1]).format('YYYY-MM-DD') : "",
      };

      const { data } = await GetSumAllMetrics(params?.id, { startDate: dateFormat.startDate, endDate: dateFormat.endDate });
      setAllMetrics(data);
    } catch (error) {

    } finally {
    }
  }

  useEffect(() => {
    fetchPosts()
    fetchTable()
    fetchSumMetricsGroupedByDate()
    sumAllMetrics()
  }, []);

  const [rangeDate, setRangeDate] = useState(null);

  const formatDate = (date) => dayjs(date).locale('pt-br').format('DD/MM/YYYY');

  return (
    <Container>


      <CalendarContainer>
        <CalendarFilterContainer onClick={() => setCalendarIsOpen(prev => !prev)} isOpen={calendarIsOpen}>
          {calendarIsOpen ? (
            <CalendarIconClose><CloseIcon /></CalendarIconClose>
          ) : (
            <CalendarIcon />
          )}
          <CalendarFilterText isOpen={calendarIsOpen}>
            {calendarIsOpen ? "Fechar" : "Filtrar"}
          </CalendarFilterText>
        </CalendarFilterContainer>

        {calendarIsOpen && (
          <CalendarWrapper>
            <CustomCalendar
              onClickDay={(value) => setRangeDate([value, value])}
              formatShortWeekday={(locale, date) => date.toLocaleDateString(locale, { weekday: 'narrow' })}
              tileClassName={({ date, view }) => {
                if (rangeDate && Array.isArray(rangeDate)) {
                  const [start, end] = rangeDate;
                  if (start && end && date >= start && date <= end) {
                    return 'highlight-range'; // Classe CSS personalizada
                  }
                }
                return null;
              }}
              selectRange={true} onChange={setRangeDate} value={rangeDate} />
            {Array.isArray(rangeDate) && rangeDate.length === 2 && (
              <RangeDataTextContainer>
                <RangeDataText>De {formatDate(rangeDate[0])}</RangeDataText>
                <RangeDataText>Até {formatDate(rangeDate[1])}</RangeDataText>
              </RangeDataTextContainer>
            )}

            <div style={{ display: "flex" }}>
              <ConfirmBtn
                onClick={() => {
                  setCalendarIsOpen(false);
                  fetchPosts(null);
                  fetchTable(null);
                  fetchSumMetricsGroupedByDate(null);
                  sumAllMetrics(null);
                  setRangeDate(null);
                }}
                style={{ background: "#F4F4F4", color: "#5A5364" }}
              >
                Limpar filtro
              </ConfirmBtn>

              <ConfirmBtn
                onClick={() => {
                  setCalendarIsOpen(false);
                  fetchPosts(rangeDate);
                  fetchPosts(rangeDate);
                  fetchTable(rangeDate);
                  fetchSumMetricsGroupedByDate(rangeDate);
                  sumAllMetrics(rangeDate);
                }}
              >
                Confirmar
              </ConfirmBtn>
            </div>
          </CalendarWrapper>
        )}
      </CalendarContainer>

      <DraggableAccordion title='Visão Geral' icon="helix-orange">
        <ContentContainer style={{ overflow: "hidden" }}>
          <TotalViewsCard data={allMetrics} />
          <ChartCard totals={sumMetricsGroupedByDate?.totals.interactions} data={{ daily: sumMetricsGroupedByDate?.daily.map(data => ({ createdAt: data.day, value: data.interactions })), monthly: sumMetricsGroupedByDate?.monthly.map(data => ({ createdAt: data.day, value: data.interactions })) }} title="Aumento de engajamentos" />
        </ContentContainer>
      </DraggableAccordion>

      <DraggableAccordion title='Interação' icon="retangle-green">
        <ContentContainer style={{ overflow: "hidden" }}>
          <ChartCard totals={sumMetricsGroupedByDate?.totals.likes} data={{ daily: sumMetricsGroupedByDate?.daily.map(data => ({ createdAt: data.day, value: data.likes })), monthly: sumMetricsGroupedByDate?.monthly.map(data => ({ createdAt: data.day, value: data.likes })) }} title="Curtidas/Reações" />
          <ChartCard totals={sumMetricsGroupedByDate?.totals.comments} data={{ daily: sumMetricsGroupedByDate?.daily.map(data => ({ createdAt: data.day, value: data.comments })), monthly: sumMetricsGroupedByDate?.monthly.map(data => ({ createdAt: data.day, value: data.comments })) }} title="Comentários" />
          <ChartCard totals={sumMetricsGroupedByDate?.totals.views} data={{ daily: sumMetricsGroupedByDate?.daily.map(data => ({ createdAt: data.day, value: data.views })), monthly: sumMetricsGroupedByDate?.monthly.map(data => ({ createdAt: data.day, value: data.views })) }} title="Visualizações" />
          <PieChartCard data={allMetrics} />
        </ContentContainer>

      </DraggableAccordion>

      <DraggableAccordion title='Mídia' icon="cube-purple">
        <ContentContainerFlex>
          {posts?.map((post, index) => (
            <Media key={index} data={post} postUrl={`https://www.instagram.com/p/${post.post_url}/`} />
          ))}
        </ContentContainerFlex>

      </DraggableAccordion>

      <DraggableAccordion title='Creators' icon="cylinder-yellow" >
        <CreatorsTable data={table} postUrl="https://www.instagram.com/p/DEaFaAYAhCW/" />
      </DraggableAccordion>
    </Container>
  );
}
